<script>
    import {http} from '@/system/http.js';
    import Card from '@/online_booking/new/components/common/Card';
    import StepCounter from '@/online_booking/new/components/common/StepCounter';
    import PreviousButton from '@/online_booking/new/components/common/PreviousButton';
    import {mapActions, mapGetters, mapState} from 'vuex';

    export default {
        data() {
            return {
                active: false,
                visible: false,
                loading: false,
                slug: null,
                publishable_key: Config.get('app.STRIPE_PUBLISHABLE_KEY'),
                dataFrm: null,
                event: null,
                payment_error: '',
                payment_rate_request: 0,
                stripe : false,
                stripe_card : false,
                stripe_payment_intent_secret : false,
                currency: Config.get('countries.' + locale + '.currency'),
            }
        },

        mounted() {
            this.$event_bus.$on('LoadEventData', (data) => {
                this.event = data.event;
                this.slug = data.event.slug;

                if (data.event.is_payable_with_online_payment && !this.show_waiting_list) {
                    this.visible = true;
                }
            });

            this.$event_bus.$on('eventPayment', (data) => {
                this.active = true;
                if ($(window).width() < 500) {
                    setTimeout(function(){
                        $('html, body').animate({scrollTop:$('#confirm-event-panel').offset().top});
                    }, 250);
                };
                this.dataFrm = data.dataFrm;
                this.event = data.data.event;
                this.stripe_payment_intent_secret = data.data.payment_intent_secret;
                this.payment_rate_request = data.payment_rate_request;
                this.setCurrentStep('payment');
            });

            this.$event_bus.$on('event-restart', () => {
                this.active = false;
            });

            this.$event_bus.$on('FillEventInfoShowed', () => {
                this.active = false;
            });

            this.$event_bus.$on('EventClientsShowed', () => {
                this.active = false;
            });

            this.$event_bus.$on('ConfirmEventShowed', () => {
                this.active = false;

                if (this.used_voucher || this.totalEventPriceToPayNow <= 0 || !this.event.pay_before || this.show_waiting_list) {
                    this.visible = false;
                } else {
                    this.visible = true;
                }
            });

            $(document).ready(function(){
                $('[data-toggle="tooltip"]').tooltip();
            });

            if (typeof Stripe !== 'undefined') {
                this.stripe = Stripe(this.publishable_key, { locale: moment_locale });

                var style = {
                    base: {
                        // Add your base input styles here. For example:
                        fontSize: '16px',
                        color: "#505458",
                    }
                };

                this.stripe_card = this.stripe.elements().create('card', {style: style});
                this.stripe_card.mount('#card-element');
            }
        },

        watch: {
            used_voucher(newVal){
                if (newVal && this.event && !this.event.is_payable_with_online_payment) {
                    this.visible = false;
                } else {
                    this.visible = true;
                }
            },

            totalEventPriceToPayNow(priceToPay) {
                if (priceToPay > 0 && this.event && this.event.is_payable_with_online_payment && !this.show_waiting_list) {
                    this.visible = true;
                } else {
                    this.visible = false;
                }
            },

            visible (newValue) {
                this.setPaymentStepVisibility(newValue);
            },
        },

        computed: {
            ...mapState('OnlineBooking', ['currentStep']),
            ...mapGetters('OnlineBooking', ['currentStepNumber', 'totalStepCount', 'getPreviousStepId']),

            totalEventPriceToPayNow() {
                if (this.event) {
                    if (this.payment_rate_request) {
                        return this.event.first_payment_rate_price_in_cents_with_vat - this.discountMoneyUsed - this.giftcardMoneyUsed;
                    }

                    return this.event.price_in_cents_with_vat - this.giftcardMoneyUsed - this.discountMoneyUsed;
                }

                return 0;
            },

            totalEventPriceToPayNowFormatted() {
                if (this.event) {
                    return this.event.currency + ' ' + (this.totalEventPriceToPayNow / 100).toFixed(2);
                }

                return 0;
            },

            used_voucher() {
                return this.$store.getters.used_voucher;
            },

            giftcard() {
                return this.$store.getters.giftcard;
            },

            discount_code() {
                return this.$store.getters.discount_code;
            },

            giftcardMoneyUsed() {
                if (!this.event || !this.giftcard || this.giftcard.money_left <= 0) {
                    return 0;
                }

                let amountUsed = Math.min(this.event.price_in_cents_with_vat, this.giftcard.money_left);

                if (this.payment_rate_request) {
                    amountUsed = amountUsed / this.event.payment_rates_number;
                }

                return amountUsed;
            },

            giftcardMoneyUsedFormatted() {
                if (this.event) {
                    return `${this.event.currency} ${(this.giftcardMoneyUsed / 100).toFixed(2)}`;
                }
            },

            discountMoneyUsed() {
                if (!this.discount_code) {
                    return 0;
                }

                let amountUsed = 0;

                if (this.discount_code.type == 'percentage') {
                    amountUsed = this.event.price_in_cents_with_vat * (this.discount_code.value / 100);
                } else {
                    amountUsed = this.discount_code.value * 100;
                }

                if (this.payment_rate_request) {
                    amountUsed = Math.round(amountUsed / this.event.payment_rates_number);
                }


                return amountUsed;
            },

            discountMoneyUsedFormatted() {
                return `${this.event.currency} ${(this.discountMoneyUsed / 100).toFixed(2)}`;
            },

            show_waiting_list() {
              return this.event.is_filled && this.event.can_clients_singnup_for_waiting_list;
            },

            isPaymentStepActive () {
                return this.currentStep === 'payment';
            }
        },

        methods: {
            ...mapActions('OnlineBooking', ['setCurrentStep', 'setPaymentStepVisibility']),

            pay() {
                this.loading = true;
                this.stripe.handleCardPayment( this.stripe_payment_intent_secret, this.stripe_card, {} ).then( (response) => this.stripeResponseHandler(response) );
            },

            stripeResponseHandler(response) {
                this.payment_error = '';

                if (response.error) {
                    this.payment_error = this.getStripeErrorMessage(response.error.message, response.error.code);
                    this.loading = false;
                } else {
                    this.payBooking(response.paymentIntent);
                }
            },

            payBooking(payment_intent) {
                this.dataFrm.append('payment_intent_id', payment_intent.id);
                this.dataFrm.append('payment_intent_payment_method', payment_intent.payment_method);

                this.dataFrm.append('payment_rate_request', this.payment_rate_request);

                if (this.giftcard) {
                    this.dataFrm.append('giftcard_id', this.giftcard.id);
                }

                if (this.discount_code) {
                    this.dataFrm.append('discount_code_id', this.discount_code.id);
                }

                http.post('/event/' + this.slug + '/pay', this.dataFrm)
                    .then(({data}) => {
                        this.$event_bus.$emit('infoEventAdded', data.markup);
                        this.loading = false;
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                        if (errorBag) {
                            this.$setErrorBag(errorBag);
                        }
                    });
            },

            getStripeErrorMessage(message, code) {

                if (code == "invalid_expiry_month" || code == "invalid_expiry_year") {
                    return trans('online_payment.card_date_error');
                }

                if (code == "incorrect_number" || code == 'invalid_number') {
                    return trans('online_payment.card_number_error');
                }

                if (code == 'invalid_cvc' || code == 'incorrect_cvc') {
                    return trans('online_payment.card_cvc_error');
                }

                if (code == 'expired_card') {
                    return trans('online_payment.card_expired');
                }

                if (code == 'card_declined') {
                    return trans('online_payment.card_declined');
                }

                if (code == 'processing_error' || code == 'rate_limit') {
                    return trans('online_payment.card_error');
                }

                return message;

            },
        },

        components: {
            Card,
            StepCounter,
            PreviousButton,
        },
    };

</script>


<template id="event-payment">
    <div v-show="visible && isPaymentStepActive">
        <card class="p-0 rounded-lg" id="event-payment-panel">
            <!-- Main Section Title -->
            <h4 class="section-title">
                <step-counter :current="currentStepNumber" :total="totalStepCount" />
                {{ trans('online_payment.payment_heading') }}
            </h4>
            <div
                id="collapseEventPayment"
                role="tabpanel"
                aria-labelledby="headingClients"
                data-parent="#event-accordion"
            >
                <div
                    class="panel-body"
                    id="choose-user-body-booking"
                >
                    <div class="row">
                        <div class="col-xs-12">
                            <ep-banner class="mb-6" v-if="event && event.online_payment_reserve">
                                <i class="zmdi zmdi-info-outline m-r-10 alert-ico"></i>
                                <strong>
                                    {{ trans('online_payment.online_payment_public_name') }}
                                </strong><br/>
                                <span class="alert-indent">{{ trans('events.payment_reserve') }}</span>
                            </ep-banner>

                            <ep-banner variant="danger" class="mb-6" v-if="payment_error">
                                <i class="zmdi zmdi-alert-triangle m-r-10 alert-ico"></i>
                                <span>{{ payment_error }}</span>
                            </ep-banner>

                            <div class="flex flex-column sm:flex-col-reverse space-y-6 sm:space-y-reverse">
                                <div class="well shadow-none mb-0">
                                    <form v-on:submit.prevent="pay" id="payment-frm" class="form-horizontal" role="form">
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div id="card-element" class="card-box"></div>
                                            </div>
                                        </div>

                                        <button type="submit" class="btn btn-block btn-lg btn-custom collapsed" v-if="!loading">
                                            <i class="zmdi zmdi-check"></i>
                                            <span class="m-l-10">{{ trans('online_payment.submit') }} {{ totalEventPriceToPayNowFormatted }}</span>
                                        </button>

                                        <div class="btn btn-block btn-lg btn-custom btn-payment-loading"
                                             v-if="loading">
                                            <div class="preloader"></div>
                                        </div>

                                        <p class="text-center secure-payment m-t-5">
                                            <small>
                                                <span class="zmdi zmdi-lock m-r-5" aria-hidden="true"></span>
                                                {{ trans('online_payment.secure_payments_new') }} <a :href="trans('online_payment.easypay_website_url')"
                                                                                                     target="_blank">EasyPay</a> {{ trans('global.and') }} <a
                                                href="https://stripe.com" target="_blank">Stripe</a>
                                            </small>
                                        </p>

                                    </form>
                                </div>
                                <div class="payment-box" v-if="active">
                                    <form class="form-horizontal" role="form">

                                        <h5 class="m-t-0">{{ trans('online_payment.online_booking_payment_heading_event') }}</h5>

                                        <hr>

                                        <div class="form-group m-b-10">
                                            <label class="col-sm-4 control-label">{{ trans('settings.amount') }}</label>
                                            <div class="col-sm-8">
                                                <div class="form-control-static" v-if="payment_rate_request">
                                                    {{ event.first_payment_rate_price_with_vat_formatted }}
                                                </div>
                                                <div class="form-control-static" v-else>
                                                    {{ event.price_formatted_with_vat }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group m-b-10" v-if="discountMoneyUsed">
                                            <label class="col-sm-4 control-label">{{ trans('global.discount') }}</label>
                                            <div class="col-sm-8">
                                                <div class="form-control-static">
                                                    - {{ discountMoneyUsedFormatted }}
                                                    ({{ discount_code.code }}
                                                    {{ discount_code.type == 'percentage' ? discount_code.value + '%' : currency + ' ' + discount_code.value }})
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group m-b-10" v-if="giftcardMoneyUsed">
                                            <label class="col-sm-4 control-label">{{ trans('giftcards.title') }}</label>
                                            <div class="col-sm-8">
                                                <div class="form-control-static">
                                                    - {{ giftcardMoneyUsedFormatted }} ({{ giftcard.name }})
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group m-b-10">
                                            <label class="col-sm-4 control-label">
                                                {{ trans('online_booking.receipt_time') }}
                                            </label>
                                            <div class="col-sm-8">
                                                <div class="form-control-static">
                                                    {{ event.interval_formatted }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group m-b-0">
                                            <label class="col-sm-4 control-label m-b-0">{{ trans('events.event')
                                                }}</label>
                                            <div class="col-sm-8">
                                                <div class="form-control-static">{{ event.name }}</div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <previous-button class="p-6 pt-0" :previous-step-id="getPreviousStepId" />
            </div>
        </card>
    </div>

</template>

<style scoped lang="scss">
    .payment-cards img {
        width: 50px;
        height: auto;
        margin-right: 10px;
    }

    .card-box {
        .alert {
            margin-top: 0 !important;
        }
    }
</style>
